var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "stretched policy-container" },
    [
      _c("div", { attrs: { id: "wrapper" } }, [
        _c(
          "div",
          {
            class:
              "container " +
              (_vm.$vuetify.breakpoint.xsOnly ? "pt-4 px-4 mb-2" : "pt-3 mb-6"),
          },
          [
            _c(
              "div",
              { staticClass: "d-inline-flex w-100 justify-content-start" },
              [
                _c(
                  "div",
                  { staticClass: "d-inline-flex w-50 align-items-center" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "policy-back-link", attrs: { to: "/" } },
                      [
                        _c("img", {
                          attrs: {
                            src: "/content/svgs/arrow-back.svg",
                            alt: "back",
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "w-50 d-flex justify-content-end",
                    attrs: { id: "logo" },
                  },
                  [
                    _c("router-link", { attrs: { to: "/" } }, [
                      _c("img", {
                        staticClass: "logo-default",
                        attrs: {
                          srcset: "/content/images/stemdo-black-logo.png",
                          src: "/content/images/stemdo-black-logo.png",
                          alt: "Stemdo Logo",
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            class: _vm.$vuetify.breakpoint.xsOnly ? "px-3" : "",
            attrs: { id: "content" },
          },
          [
            _c("div", { staticClass: "content-wrap" }, [
              _c("div", { staticClass: "container policy-content" }, [
                _c(
                  "h1",
                  { staticClass: "ppmountent text-main-color policy-title" },
                  [_vm._v("Contacto")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Si tienes cualquier consulta, sugerencia o necesitas ponerte en contacto con nosotros, puedes hacerlo a través de los\n            siguientes canales:\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("h2", [_vm._v("Redes sociales")]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("h2", [_vm._v("Protección de datos")]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-dark-grey-color" },
                  [
                    _vm._v(
                      "\n            Para más información, consulta nuestra "
                    ),
                    _c("router-link", { attrs: { to: "/privacy" } }, [
                      _vm._v("Política de Privacidad"),
                    ]),
                    _vm._v(" y nuestra\n            "),
                    _c("router-link", { attrs: { to: "/cookies" } }, [
                      _vm._v("Política de Cookies"),
                    ]),
                    _vm._v(".\n          "),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("footer", { attrs: { id: "footer" } }, [
          _c("div", { attrs: { id: "copyrights" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-7 text-center copyright-links" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-around px-2" },
                      [
                        _c("router-link", { attrs: { to: "/privacy" } }, [
                          _c("u", [_vm._v("Política de privacidad")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/cookies" } }, [
                          _c("u", [_vm._v("Política de Cookies")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/legal" } }, [
                          _c("u", [_vm._v("Aviso Legal")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/contact" } }, [
                          _c("u", [_vm._v("Contacto")]),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._m(5),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("SCookieBanner"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v("\n            C/ Villa de Madrid 17, 21001, Huelva"),
      _c("br"),
      _vm._v(" "),
      _c("a", { attrs: { href: "tel:+34959469471" } }, [
        _vm._v("+34 959 469 471"),
      ]),
      _vm._v(" | "),
      _c("a", { attrs: { href: "mailto:hola@stemdo.io" } }, [
        _vm._v("hola@stemdo.io"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v(
        "\n            Para información detallada sobre nuestras sedes, direcciones y medios de contacto disponibles, visita nuestra\n            página de contacto "
      ),
      _c(
        "a",
        { attrs: { href: "https://stemdo.io/contacto", target: "_blank" } },
        [_vm._v("aquí")]
      ),
      _vm._v(".\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "text-dark-grey-color" }, [
      _c("li", [
        _c("strong", [_vm._v("Instagram:")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/stemdo_io/?hl=es",
              target: "_blank",
            },
          },
          [_vm._v("@stemdo_io")]
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("LinkedIn:")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.linkedin.com/company/stemdo/",
              target: "_blank",
            },
          },
          [_vm._v("linkedin.com/company/stemdo")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v(
        "\n            Para ejercer tus derechos en materia de protección de datos o para cualquier consulta relacionada con el tratamiento\n            de tu información personal, puedes contactar con nuestro Delegado de Protección de Datos (DPD) en:\n            "
      ),
      _c("a", { attrs: { href: "mailto:dpd@stemdo.io" } }, [
        _vm._v("dpd@stemdo.io"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "col-md-3 text-center text-md-start",
        staticStyle: { color: "#606061" },
      },
      [_c("b", [_vm._v("Stemdo © 2024")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "col-md-2 text-center text-md-end pb-4 pb-sm-0" },
      [
        _c("div", { staticClass: "d-flex justify-content-around" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.instagram.com/stemdo_io/?hl=es",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/instagram-icon.png",
                  alt: "Instagram icon",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/stemdo/",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/linkedin-icon.png",
                  alt: "Linkedin icon",
                },
              }),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }